import { render } from "./ClassGenderCard.vue?vue&type=template&id=58352a28&scoped=true"
import script from "./ClassGenderCard.vue?vue&type=script&lang=js"
export * from "./ClassGenderCard.vue?vue&type=script&lang=js"

import "./ClassGenderCard.vue?vue&type=style&index=0&id=58352a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58352a28"]])

export default __exports__